import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material"; // Changed to Material-UI Button
import { Box } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

const BackToCPQButton = () => {
    const location = useLocation();

    const navigate = useNavigate();
    const queryParams = location.search; // Preserve query params like ?id=...

    return (
        <Box sx={{ mb: 3, mt: 2, display: "flex", justifyContent: "center" }}>
            <Button
                variant="contained"
                color="secondary"
                startIcon={<ArrowBack />}
                onClick={() => navigate(`/cpq-home${queryParams}`)}
            >
                Back to CPQ Home
            </Button>
        </Box>
    );
};

export default BackToCPQButton;
